import { getRandomId } from "client/utils/getRandomId";
import { useAppDispatch } from "store/store";
import { createImportTask } from "store/features/compress/extraReducers/createImportTask";
import { Job, Task } from "@freeconvert/freeconvert-node/dist/types";
import { PayloadAction } from "@reduxjs/toolkit";
import { FileData } from "client/types/FileData";
import { DeviceImport } from "client/services/Import/DeviceImport";
import { JobService, JobServiceOptions } from "client/services/Job/JobService";
import { get } from "client/services/Backend/get";

export const useProcessingInFC = () => {
    const dispatch = useAppDispatch();

    const getImportTask = async (): Promise<Task | null> => {
        const result = await dispatch(
            createImportTask({
                imageId: getRandomId(),
                type: "device",
                options: {},
            }),
        );
        const payload = result.payload as PayloadAction<{ result: Task }>["payload"];
        if (result.meta.requestStatus === "rejected") {
            return null;
        }
        return payload.result;
    };

    const uploadFile = async (file: FileData, importTask: Task, onProgress?: (progress: number) => void) => {
        return new Promise<void>((resolve, reject) => {
            const deviceImport = new DeviceImport(
                importTask,
                file,
                {
                    onProgress: (_task, progress) => {
                        onProgress?.(progress);
                    },
                    onComplete: () => {
                        resolve();
                    },
                    onFailure: () => {
                        reject();
                    },
                },
                {},
            );
            deviceImport.startImport();
        });
    };

    const processJob = (job: Job) => {
        return new Promise<Job>((resolve, reject) => {
            new JobService(job, {
                handleJobComplete: async ({ id }) => {
                    const result = await get<Job>(`${process.env.NEXT_PUBLIC_BE_URL}/jobs/${id}`);
                    if (!result.result || result.error) return;
                    const job = result.result;
                    resolve(job);
                },
                handleJobFail: () => reject(null),
            });
        });
    };

    return { getImportTask, uploadFile, processJob };
};
